import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './controls.module.css';
/**
 * The application's button.
 *
 * Replaces five one-off classes that grew apart (`.signin-devbtn`,
 * `.rn-btn-quiet`, `.signin-primary`, `.msg-primary`, `.msg-add-btn`). Type
 * defaults to "button" because the historical classes were applied to bare
 * <button> elements inside forms, where the browser default of "submit"
 * silently submitted the form.
 *
 * `forwardRef` so a dialog (e.g. `ConfirmAction`) can put its initial focus on
 * a specific button — critically, the SAFE one, never the destructive default.
 */
export const Button = forwardRef(function Button({ variant = 'secondary', small, block, className, type, children, ...rest }, ref) {
    const classes = [
        styles.btn,
        styles[variant],
        small ? styles.small : '',
        block ? styles.block : '',
        className ?? '',
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx("button", { ref: ref, type: type ?? 'button', className: classes, ...rest, children: children }));
});
//# sourceMappingURL=Button.js.map